<template>
    <div class="reportdetailPage">
        <van-nav-bar>
            <template #left left-arrow>
                <i @click="onTopic()" class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </template>
        </van-nav-bar>
        <div class="reportTop-bg">
            <header class="reportTitle">
                <h2>{{reportInfo.assessReportName}}</h2>
                <p>{{reportInfo.userName}} {{reportInfo.time}}</p>
            </header>
        </div>
        <div class="reportTop">
            <div class="reportInfo">
                <img :src="headImg || require('../../../assets/images/humanResting/tx@2x.png')" alt />
                <div class="reportInfoUl">
                   <p class="score">测评结果<span>{{reportInfo.modelScore}}</span></p>
                </div>
                 
            </div>
        </div>
       <div class="modelAttr" v-if="reportInfo.modelAttr">
            
            <div  class="reportInfoli" v-for="(item, index) in reportInfo.modelAttr.attrDefinitionValueList" :key="index">
                <p class="m-name">{{item.name}}</p>
                <p class="m-value">{{item.value}}</p>
            </div>
        </div>
        <!-- 柱状图 -->
        <div  class="reportchart" id="liuchart" v-if="reportInfo.dimensionDtoList  && reportInfo.dimensionDtoList.length>1"></div>
        <!-- 内容 -->
        <div class="reportContent">
            <!-- 行为特征 -->
            <!-- <div v-if="relationType === 1">
                <div v-for="(item, index) in infocontent" :key="index">
                    <div v-if="item.attributeType === 2" class="reportContent-behavior">
                        <div  class="behavior-title">
                            <div>
                                <h3>{{item.attributeName}}</h3>
                                <p>EVALUAtTION REPORT RESULTS</p>
                            </div>
                            <img src="../../../assets/images/humanResting/xwtz@2x.png" alt />
                        </div>
                        <div class="behavior-content">
                            <p class="textComm">{{item.attributeDescription}}</p>
                        </div>
                    </div>
                </div>
            </div> -->
            <div>
                <div v-for="(item, index) in infocontent" :key="index" class="reportContent-behavior">
                    <div class="behavior-title">
                        <div>
                            <h3>{{item.dimensionName}}</h3>
                            <p class="score">得分 {{item.dimensionScore}}</p>
                        </div>
                        <p class="titleImg"></p>
                    </div>
                    <div class="behavior-more-content" v-if="item.dimensionAttr && item.dimensionAttr.attrDefinitionValueList.length>0">
                        <div v-for="(rep, index) in item.dimensionAttr.attrDefinitionValueList" :key="index">
                            <div  class="moreli" >
                                <div class="singleAttri">
                                    <p class="morename">{{rep.name}}</p>
                                    <p class="moretext">{{rep.value}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content-left" v-if="item.indicatorList && item.indicatorList.length>1">
                        <div :id="'demin'+index"  style="height:240px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 免责声明 -->
        <div class="reportStatement">
            <h2>免责声明</h2>
            <section>以下说明与本测评报告正文一起构成本测评报告不可分割的统一整体。</section>
            <p>• 本测评报告基于测评者的作答情况而获得，结果代表的是测评者的自我觉知。</p>
            <p>• 本测评报告正文内容可能引发的与任何第三人之纠纷或冲突，本测评机构不承担任何法律责任。本测评机构亦不在此类纠纷或冲突中充当证人、调停人或其他形式之参与人</p>
            <p class="lastp">• 本测评报告不得用于非法之目的，本测评机构不承担任何由此而发生或可能发生之法律责任。</p>
            <section>当本测评报告打印、持有、出具、展示或以其它任何形式使用时，即表明本测评报告之持有人或接触人已审读，理解并同意以上各条款之规定。</section>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts"
export default {
    name: "reportdetail",
    data() {
        return {
            reportInfo: {},
            infocontent: [],
            nameArr: [],
            numArr: [],
            resultName: null,
            relationType: null,
            headImg: null,
        };
    },
    components: {},
    created() {
        this.findByResultIdId();
        this.getAccountUserInfo();
    },
    mounted() {},
    methods: {
        initRadar(){
            var echartx = {};
            const that = this;
            let demD = [];
            let demDName = [];
            this.infocontent.map((item,index)=>{
                if(that.infocontent && that.infocontent.length>1){
                    demDName.push({
                        name:item.dimensionName,
                        max:item?.max || undefined
                    })
                    demD.push(item.dimensionScore)
                    that.$nextTick(()=>{
                        const myChart = that.$echarts.init(document.getElementById('liuchart'));
                        myChart.setOption({
                            radar: {
                                indicator: demDName,
                                radius: 60,
                                center: ['50%', '50%'],
                            },
                            tooltip: {
                                trigger: 'item'
                            },
                            series: [
                                {
                                    type: 'radar',
                                    data: [
                                        {
                                            value:demD,
                                            name:that.reportInfo.assessReportName
                                        }
                                    ]
                                }
                            ]
                        })
                    })
                }
                if(item.indicatorList && item.indicatorList.length>1){
                    const dataD = item.indicatorList.map((e)=>{
                        return e.score
                    })
                    const tempData = JSON.parse(JSON.stringify(item.indicatorList).replace(/"indicatorName"/g,'"name"'))
                    that.$nextTick(()=>{
                        echartx[index]= that.$echarts.init(document.getElementById('demin'+index));
                        console.log(that.$echarts);
                        echartx[index].setOption({
                            radar: {
                                indicator: tempData,
                                radius: 60,
                                center: ['50%', '50%'],
                            },
                            tooltip: {
                                trigger: 'item'
                            },
                            series: [
                                {
                                    type: 'radar',
                                    data: [
                                        {
                                        value:dataD,
                                        name:item.dimensionName
                                        }
                                    ]
                                }
                            ]
                        })
                    })
                }
            })
        },
        getAccountUserInfo () {
            const headers = {
                "token": localStorage.getItem('token')
            }
            return this.$api.usercenter.getAccountUserInfo({ headers }).then(res => {
                this.headImg = res.data.headImage;
            }).catch(() => {
                return null
            })
        },
        // 返回上题
        onTopic() {
            this.$router.push({
                path: this.$route.query.refId
                    ? "/humanResting/hrDetails"
                    : "/testreport",
                query: this.$route.query.refId
                    ? {
                            id: this.$route.query.id,
                            refId: this.$route.query.refId,
                            isValid: this.$route.query.isValid,
                            refType: this.$route.query.refType,
                            backType: this.$route.query.backType || '',
                            goodsId: this.$route.query.goodsId || '',
                        }
                    : null
            });
        },
        getmoreEchart(data) {
            data.forEach(item => {
                this.numArr.push(item.score);
                this.nameArr.push(item.indicatorName);
            });
        },
        async findByResultIdId() {
            let datalist = null;
            if (this.$route.query.refId) {
                let params = {
                    resultId: this.$route.query.resultId
                };
                await this.$api.testreport
                    .findByResultIdId({ params })
                    .then(res => {
                        datalist = res.data;
                    });
            } else {
                let params = {
                    id: this.$route.query.resultId
                };
                await this.$api.testreport
                    .reportFindById({ params })
                    .then(res => {
                        datalist = res.data;
                    });
            }
            this.reportInfo = datalist; 
            this.getmoreEchart(this.reportInfo.indicatorList)
            this.relationType = datalist.relationType; // 1、单维度  2、多维度
            if(this.relationType === 1){
                // 单维度数据
                this.infocontent = this.reportInfo.dimensionDtoList[0].attributeList; 
                this.resultName = this.reportInfo.dimensionDtoList[0].resultName;
            } else if(this.relationType === 2){
                this.infocontent = this.reportInfo.dimensionDtoList;
            }
            this.infocontent = this.reportInfo.dimensionDtoList;
            this.initRadar();
        }
    }
};
</script>
<style lang="less">
.reportdetailPage {
    .van-nav-bar {
        background: #508dfe;
    }
    .van-nav-bar .van-icon {
        color: #fff;
    }
    .van-hairline--bottom::after {
        border-bottom-width: 0px;
    }
}
</style>
<style scoped lang="less">
@import "../asset/css/reportdetail";
</style>
